import { SessionHelper } from "@jnpmedi/helper-session";
import type { AuthToken } from "@maven-rest/sso/AuthToken.dto";

export type Session = Pick<AuthToken, "token" | "expiryAt">;

export type AuthKeys = {
  uuid: string;
  privateKey: string;
  publicKey: string;
};

export const sessionHelper = new SessionHelper({ stage: process.env.STAGE || "local" });
